import styled from 'styled-components';
import { StyledRteHtmlText } from '../../../../../../../inputs/rich-text/style/StyledRteHtmlText.tsx';

export const OptionsGroupDividerText = styled.div`
  ${StyledRteHtmlText};
  font-size: 16px;
  line-height: 1.3;
  margin: 0;

  padding-bottom: 2px;
  p,
  a,
  ol,
  ul,
  dl {
    font-size: 16px;
    margin: 0;
    margin-bottom: 0;
  }
`;
